import {
  base_colorContentBorder,
  base_colorRaisedSurface,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_regular,
  font_lg,
  font_sm,
  fontH2,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  border-radius: ${spacing(3)};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: ${spacing(6)};

  .AccountingSummaryBar-spendCents {
    display: flex;
    flex-direction: column;
    gap: ${spacing(2)};
    padding: ${spacing(3)};
    // defining the min-height ensures that the box lines up with the
    // StatisticsBoxes when it is not taller than them
    min-height: 102px;
    margin-right: auto;

    .AccountingSummaryBar-spendCents-header {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      gap: ${spacing(2)};
      width: max-content;

      .AccountingSummaryBar-spendCents-header-left {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: ${spacing(2)};

        .AccountingSummaryBar-spendCents-header-left-label {
          color: ${text_colorTextSecondary};
          font-family: ${font_family_weight_regular};
          ${font_sm};
        }
      }
    }

    .AccountingSummaryBar-spendCents-statistics {
      display: flex;
      flex-direction: column;
      gap: ${spacing(2)};

      .AccountingSummaryBar-spendCents-statistics-value {
        display: flex;
        flex-direction: row;
        align-items: baseline;
        gap: ${spacing(2)};
        color: ${text_colorTextPrimary};
        ${fontH2};

        // separator
        :not(:first-child) {
          border-top: 1px solid ${base_colorContentBorder};
          padding-top: ${spacing(2)};
        }

        .AccountingSummaryBar-spendCents-statistics-value-currency {
          color: ${text_colorTextPrimary};
          font-family: ${font_family_weight_regular};
          ${font_lg};
        }
      }
    }

    .AccountingSummaryBar-spendCents-separator {
      height: 1px;
      background: ${base_colorContentBorder};
    }
  }

  .AccountingSummaryBar-scrollContainer {
    overflow: hidden;
    position: relative;

    // Right side fade - hidden by default
    ::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      width: ${spacing(12)};
      background: linear-gradient(
        to right,
        transparent,
        ${base_colorRaisedSurface}
      );
      pointer-events: none;
      opacity: 0;
      transition: opacity 150ms ease-out;
    }

    // Left side fade - hidden by default
    ::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      width: ${spacing(12)};
      background: linear-gradient(
        to left,
        transparent,
        ${base_colorRaisedSurface}
      );
      pointer-events: none;
      opacity: 0;
      transition: opacity 150ms ease-out;
    }

    // Show right fade when not scrolled to the right
    &.show-right-fade::after {
      opacity: 1;
    }

    // Show left fade when not scrolled to the left
    &.show-left-fade::before {
      opacity: 1;
    }

    .AccountingSummaryBar-scrollContainer-statisticsList {
      display: flex;
      flex-direction: row;
      gap: ${spacing(2)};
      overflow-x: scroll;

      /* Hide scrollbar */
      scrollbar-width: none;
      -ms-overflow-style: none;

      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
`
